module.exports = __webpack_public_path__ + "img/specials-multislider-mazda.385a5bad.png";